import { useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, Col, Dropdown, Row } from 'react-bootstrap';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import FalconCardHeader from '@/components/common/FalconCardHeader';
import OverviewCardItem, {
  type OverviewCardItemData
} from './OverviewCardItem';
import type { ReactNode } from 'react';

type OverviewCardProps = {
  data: OverviewCardItemData[];
  title: ReactNode;
  tooltip?: ReactNode;
};

const OverviewCard = ({ data, title, tooltip }: OverviewCardProps) => {
  // کارت های استفاده شده در صفحه نمای کلی
  const cardRef = useRef<HTMLDivElement | null>(null);
  return (
    <Card ref={cardRef} className="h-md-100">
      <FalconCardHeader
        title={
          <div>
            {title} <HelpTooltip html={tooltip} />
          </div>
        }
        titleTag="h6"
        className="py-2"
        light
        endEl={
          <Dropdown
            align="end"
            className="btn-reveal-trigger d-inline-block me-0"
          >
            <Dropdown.Toggle
              className="text-600 btn-reveal"
              split
              variant="reveal"
              size="sm"
            >
              <FontAwesomeIcon icon="ellipsis-h" className="fs--2" />
            </Dropdown.Toggle>
            <Dropdown.Menu className="border py-0">
              <Dropdown.Item
                onClick={() => {
                  cardRef.current?.requestFullscreen();
                }}
                className="link-600 fs--1 d-none d-md-flex align-items-center gap-1 py-1"
              >
                تمام صفحه
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        }
      />
      <Card.Body className="py-3">
        <Row
          className="justify-content-between g-0"
          style={{ height: '150', overflowX: 'auto' }}
        >
          <Col className="pe-2">
            <OverviewCardItem data={data} />
          </Col>
        </Row>
      </Card.Body>
      <style>{`
          .card-body {
            height: 150px;
            overflow-x: auto;
          }`}</style>
    </Card>
  );
};

export default OverviewCard;
